import { STATE } from '../constants/stateClasses';
import { scroll } from './locomotive';

const SELECTORS = {
  btn: '.js-back-to-top',
};

const handleBackToTop = () => {
  const btn = document.querySelector(SELECTORS.btn);

  scroll.on('scroll', ({ scroll }) => {
    if (scroll.y > 1500) {
      btn.classList.add(STATE.active);
    } else {
      btn.classList.remove(STATE.active);
    }
  });

  btn.addEventListener('click', () => {
    scroll.scrollTo(0);
  });
};

export default handleBackToTop;
